/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
* Equal height Flickity
* Ref: https://github.com/metafizzy/flickity/issues/534#issuecomment-328859144
*/

Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
};


// Delivery ETA
class DeliveryETA extends HTMLElement {
  months = {
    0: "January",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "August",
    8: "September",
    9: "October",
    10: "November",
    11: "December",
  };

  constructor() {
    super();
    this.num = this.getElementsByClassName("num")[0].value;
    let shippingDate = this.addWorkDays(new Date());
    this.innerText = shippingDate;
  }

  addWorkDays(startDate) {
    if (isNaN(this.num)) {
      console.log('Value provided for "days" was not a number');
      return;
    }
    if (!(startDate instanceof Date)) {
      console.log('Value provided for "startDate" was not a Date object');
      return;
    }
    // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
    var dow = startDate.getDay();
    var daysToAdd = parseInt(this.num);
    // If the current day is Sunday add one day
    if (dow == 0) daysToAdd++;
    // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
    if (dow + daysToAdd >= 6) {
      //Subtract days in current working week from work days
      var remainingWorkDays = daysToAdd - (5 - dow);
      //Add current working week's weekend
      daysToAdd += 2;
      if (remainingWorkDays > 5) {
        //Add two days for each working week by calculating how many weeks are included
        daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
        //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks
        if (remainingWorkDays % 5 == 0) daysToAdd -= 2;
      }
    }
    startDate.setDate(startDate.getDate() + daysToAdd);
    return startDate.getDate() + " " + this.months[startDate.getMonth()];
  }
}

customElements.define("delivery-eta", DeliveryETA);

// Create a custom section handler for collection tabs
class CollectionTabsSection {
  constructor(element) {
    this.element = element;
    this.tabTitles = this.element.querySelectorAll('.collection-tabs__tab-title');
    this.tabContents = this.element.querySelectorAll('.collection-tabs__tab-content-item');
    this.collectionLinks = this.element.querySelectorAll('.collection-tabs__collection-link');
    this.flickityInstances = [];
    
    this._setupTabs();
    this._setupCarousels();
    this._attachListeners();
  }

  _setupTabs() {
    // Setup tabs - hide all except first
    this.tabContents.forEach((content, index) => {
      if (index === 0) {
        content.style.display = 'block';
        this.tabTitles[0].classList.add('is-active');
      } else {
        content.style.display = 'none';
      }
    });
  }

  _setupCarousels() {
    // Initialize both collection and product carousels
    this.tabContents.forEach(content => {
      // Initialize collection carousel
      const collectionsContainer = content.querySelector('.collection-tabs__collections');
      if (collectionsContainer) {
        try {
          const flickityInstance = new Flickity(collectionsContainer, {
            pageDots: false,
            prevNextButtons: true,
            contain: true,
            cellAlign: collectionsContainer.childElementCount < 8 ? "center" : "left",
            groupCells: true,
            resize: false,
            draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
            watchCSS: true
          });
          
          collectionsContainer._flickityInstance = flickityInstance;
          this.flickityInstances.push(flickityInstance);
        } catch (error) {
          console.error('Error initializing Flickity for collections:', error);
        }
      }

      // Initialize product carousels
      const carousels = content.querySelectorAll('.product-list-carousel');
      carousels.forEach(carousel => {
        // Only initialize carousel if there are more than 4 items
        if (carousel.children.length > 4) {
          try {
            const flickityInstance = new Flickity(carousel, {
              pageDots: false,
              prevNextButtons: true,
              contain: true,
              cellAlign: 'left',
              groupCells: true,
              resize: false,
              draggable: !window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches,
              watchCSS: true
            });
            
            carousel._flickityInstance = flickityInstance;
            this.flickityInstances.push(flickityInstance);
          } catch (error) {
            console.error('Error initializing Flickity:', error);
          }
        }
      });
    });
  }

  _showCollectionProducts(collectionId) {
    // Find the tab content containing this collection
    this.tabContents.forEach(content => {
      const productsItem = content.querySelector(`.collection-tabs__products-item[data-collection-id="${collectionId}"]`);
      if (productsItem) {
        // Show the tab content
        content.style.display = 'block';
        
        // Update active tab title
        const tabIndex = Array.from(this.tabContents).indexOf(content);
        this.tabTitles.forEach((title, index) => {
          if (index === tabIndex) {
            title.classList.add('is-active');
          } else {
            title.classList.remove('is-active');
          }
        });

        // Hide all product items in this tab
        content.querySelectorAll('.collection-tabs__products-item').forEach(item => {
          item.style.display = 'none';
        });

        // Show the selected product item
        productsItem.style.display = 'block';

        // Update active collection link - only within the current tab content
        const currentTabCollectionLinks = content.querySelectorAll('.collection-tabs__collection-link');
        currentTabCollectionLinks.forEach(link => {
          if (link.closest('[data-collection-id]').dataset.collectionId === collectionId) {
            link.classList.add('is-active');
          } else {
            link.classList.remove('is-active');
          }
        });

        // Resize all Flickity instances in the visible content
        const allCarousels = content.querySelectorAll('.collection-tabs__collections, .product-list-carousel');
        allCarousels.forEach(carousel => {
          if (carousel._flickityInstance) {
            carousel._flickityInstance.resize();
          }
        });
      } else {
        content.style.display = 'none';
      }
    });
  }

  _attachListeners() {
    // Add tab switching functionality
    this.tabTitles.forEach((title, index) => {
      title.addEventListener('click', (event) => {
        event.preventDefault();
        
        // Update active tab title
        this.tabTitles.forEach(t => t.classList.remove('is-active'));
        title.classList.add('is-active');
        
        // Show selected tab content, hide others
        this.tabContents.forEach((content, contentIndex) => {
          if (contentIndex === index) {
            content.style.display = 'block';
            
            // Resize all Flickity instances in the visible tab
            const allCarousels = content.querySelectorAll('.collection-tabs__collections, .product-list-carousel');
            allCarousels.forEach(carousel => {
              if (carousel._flickityInstance) {
                carousel._flickityInstance.resize();
              }
            });
          } else {
            content.style.display = 'none';
          }
        });
      });
    });

    this.collectionLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const collectionId = link.closest('[data-collection-id]').dataset.collectionId;
        this._showCollectionProducts(collectionId);
      });
    });
    
    // Handle window resize
    window.addEventListener('resize', () => {
      this.flickityInstances.forEach(instance => {
        if (instance && typeof instance.resize === 'function') {
          instance.resize();
        }
      });
    });
  }
  
  // Required section lifecycle methods
  onUnload() {
    // Destroy all Flickity instances when section is unloaded
    this.flickityInstances.forEach(instance => {
      if (instance && typeof instance.destroy === 'function') {
        instance.destroy();
      }
    });
  }
}
// Collection tabs section with carousel functionality
document.addEventListener('DOMContentLoaded', function() {
  // Register the custom section handler with the theme's section manager
  if (window.Shopify && window.Shopify.designMode) {
    // If in theme editor, wait for the section manager to be available
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId && event.detail.container.dataset.sectionType === 'collection-tabs') {
        new CollectionTabsSection(event.detail.container);
      }
    });
  } else {
    // In regular mode, initialize all collection tabs sections
    document.querySelectorAll('[data-section-type="collection-tabs"]').forEach(section => {
      new CollectionTabsSection(section);
    });
  }

  // Initialize review carousels
  const reviewCarousels = document.querySelectorAll('.review-carousel');
  reviewCarousels.forEach(carousel => {
    // Get Flickity instance
    const flkty = new Flickity(carousel, {
      freeScroll: true,
      contain: false,
      draggable: true,
      wrapAround: true,
      autoPlay: 2000,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      pageDots: false
    });

    // Override the default behavior to keep playing after user interaction
    flkty.on('staticClick', () => {
      flkty.playPlayer();
    });
    
    flkty.on('pointerDown', () => {
      flkty.playPlayer();
    });
    
    flkty.on('dragEnd', () => {
      flkty.playPlayer();
    });

    flkty.on('mouseleave', () => {
      flkty.playPlayer();
    });

    // Ensure autoplay starts
    flkty.playPlayer();
  });

  const productVideos = document.querySelectorAll('.product-video-carousel');
  console.log('Found product video carousels:', productVideos.length);
  
  productVideos.forEach(carousel => {
    const productVideoItems = carousel.querySelectorAll('.product-video-item');
    console.log('Found product video items:', productVideoItems.length);
    
    // Initialize video toggling for any number of videos
    if(productVideoItems.length > 0) {
      playVideoToggle(carousel);
    }

    // Only initialize Flickity if there are multiple videos
    if(productVideoItems.length > 1) {
      const flkty = new Flickity(carousel, {
        freeScroll: true,
        contain: false,
        draggable: true,
        wrapAround: true,
        autoPlay: false,
        pageDots: false
      });

      // Pause all videos when changing slides
      flkty.on('change', function() {
        const videos = carousel.querySelectorAll('video');
        videos.forEach(video => {
          if (!video.paused) {
            video.pause();
            const videoItem = video.closest('.video-item');
            if (videoItem) {
              videoItem.dataset.action = 'play-video';
            }
          }
        });
      });

      // Handle drag events to pause videos
      flkty.on('dragStart', function() {
        const videos = carousel.querySelectorAll('video');
        videos.forEach(video => {
          if (!video.paused) {
            video.pause();
            const videoItem = video.closest('.video-item');
            if (videoItem) {
              videoItem.dataset.action = 'play-video';
            }
          }
        });
      });
    }
  });
});

/**
 * NavDropdownHeightManager
 * Synchronizes heights of all nav-dropdown elements to the tallest one
 */
class NavDropdownHeightManager {
  constructor() {
    this.dropdowns = [];
    this._init();
  }

  _init() {
    // Set up listeners for events that might change dropdown state
    this._setupListeners();
    
    // Set up mutation observer for dropdown changes
    this._setupMutationObserver();
    
    // Do initial sync
    this._syncHeights();
  }

  _setupMutationObserver() {
    // Use MutationObserver to detect when dropdowns are shown/hidden
    if ("MutationObserver" in window) {
      this.dropdownObserver = new MutationObserver((mutations) => {
        let needsSync = false;
        
        mutations.forEach((mutation) => {
          // Only process attribute mutations
          if (mutation.type === 'attributes') {
            // If aria-hidden or aria-expanded changed
            if (mutation.attributeName === 'aria-hidden' || 
                mutation.attributeName === 'aria-expanded' ||
                mutation.attributeName === 'class') {
              needsSync = true;
            }
          }
        });
        
        if (needsSync) {
          // Delay the height sync to ensure DOM is fully updated
          setTimeout(() => this._syncHeights(), 10);
        }
      });
      
      // Observe all dropdown containers
      document.querySelectorAll('.nav-dropdown, .nav-bar__item').forEach((dropdown) => {
        this.dropdownObserver.observe(dropdown, { 
          attributes: true,
          attributeFilter: ['aria-hidden', 'aria-expanded', 'class'],
          subtree: true
        });
      });
    }
  }

  _setupListeners() {
    // Theme events
    document.addEventListener('shopify:section:load', () => {
      this._syncHeights();
      this._setupMutationObserver(); // Re-setup observers when sections load
    });
    document.addEventListener('shopify:section:unload', () => this._syncHeights());
    
    // Listen for window resize events (with debounce)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this._syncHeights(), 250);
    });
    
    // Listen for dropdown state changes
    document.addEventListener('click', (event) => {
      const navLink = event.target.closest('.nav-bar__link, .nav-dropdown__link');
      if (navLink && navLink.hasAttribute('aria-expanded')) {
        // Delay to allow DOM updates
        setTimeout(() => {
          this._syncHeights();
          this._checkDropdownPosition();
        }, 50);
      }
    });

    // Also listen for mouseover events when using hover navigation
    document.addEventListener('mouseover', (event) => {
      const navLink = event.target.closest('.nav-bar__link[aria-haspopup="true"], .nav-dropdown__link[aria-haspopup="true"]');
      if (navLink) {
        // Delay to allow DOM updates
        setTimeout(() => {
          this._syncHeights();
          this._checkDropdownPosition();
        }, 50);
      }
    });

    // Handle direct interaction with dropdowns
    document.addEventListener('mouseenter', (event) => {
      if (event.target && event.target.classList && event.target.classList.contains('nav-dropdown')) {
        setTimeout(() => {
          this._syncHeights();
          this._checkDropdownPosition();
        }, 50);
      }
    }, true);

    // Listen for theme's built-in dropdown events
    document.addEventListener('dropdown:opened', () => {
      setTimeout(() => {
        this._syncHeights();
        this._checkDropdownPosition();
      }, 50);
    });
  }

  // Check dropdown positioning to ensure they don't go off-screen
  _checkDropdownPosition() {
    const dropdowns = document.querySelectorAll('.nav-dropdown[aria-hidden="false"]');
    const viewportWidth = window.innerWidth;
    
    dropdowns.forEach(dropdown => {
      const rect = dropdown.getBoundingClientRect();
      
      // Check if dropdown is going off the right edge
      if (rect.right > viewportWidth) {
        // If floating dropdown, add inverse class to open to the left
        if (dropdown.classList.contains('nav-dropdown--floating')) {
          dropdown.classList.add('nav-dropdown--inverse');
        } 
        // Otherwise, adjust the left position to ensure it's visible
        else {
          const overflowAmount = rect.right - viewportWidth;
          dropdown.style.left = `-${overflowAmount + 20}px`; // Add some buffer
        }
      }
      
      // Check nested dropdowns inside this dropdown
      const nestedDropdowns = dropdown.querySelectorAll('.nav-dropdown--floating');
      nestedDropdowns.forEach(nested => {
        if (nested.getAttribute('aria-hidden') === 'false') {
          const nestedRect = nested.getBoundingClientRect();
          if (nestedRect.right > viewportWidth) {
            nested.classList.add('nav-dropdown--inverse');
          }
        }
      });
    });
  }

  _syncHeights() {
    // Get all dropdowns at each level
    const level1Dropdowns = document.querySelectorAll('.nav-dropdown:not(.nav-dropdown--floating)');
    const level2Dropdowns = document.querySelectorAll('.nav-dropdown--floating');
    
    // Reset all heights and positions to auto first to get natural heights
    [...level1Dropdowns, ...level2Dropdowns].forEach(dropdown => {
      dropdown.style.height = 'auto';
      // Clear any previously set left position
      if (!dropdown.classList.contains('nav-dropdown--floating')) {
        dropdown.style.left = '';
      }
    });
    
    // Calculate max height for level 1 dropdowns
    let maxLevel1Height = 0;
    level1Dropdowns.forEach(dropdown => {
      if (dropdown.getAttribute('aria-hidden') === 'false') {
        maxLevel1Height = Math.max(maxLevel1Height, dropdown.scrollHeight);
      }
    });
    
    // Calculate max height for level 2 dropdowns
    let maxLevel2Height = 0;
    level2Dropdowns.forEach(dropdown => {
      if (dropdown.getAttribute('aria-hidden') === 'false') {
        maxLevel2Height = Math.max(maxLevel2Height, dropdown.scrollHeight);
      }
    });
    
    // Apply heights to level 1 dropdowns
    if (maxLevel1Height > 0) {
      level1Dropdowns.forEach(dropdown => {
        if (dropdown.getAttribute('aria-hidden') === 'false') {
          dropdown.style.height = `${maxLevel1Height}px`;
          
          // Ensure z-index is higher than siblings to maintain visibility
          const parentMenuItem = dropdown.closest('.nav-bar__item');
          if (parentMenuItem) {
            const siblings = Array.from(parentMenuItem.parentNode.children);
            const index = siblings.indexOf(parentMenuItem);
            dropdown.style.zIndex = 10 + siblings.length - index;
          }
        }
      });
    }
    
    // Apply heights to level 2 dropdowns
    if (maxLevel2Height > 0) {
      level2Dropdowns.forEach(dropdown => {
        if (dropdown.getAttribute('aria-hidden') === 'false') {
          dropdown.style.height = `${maxLevel2Height}px`;
        }
      });
    }
    
    // Check dropdown positions after height adjustments
    this._checkDropdownPosition();
  }
  
  // Method to manually trigger the sync (can be called externally if needed)
  forceSync() {
    this._syncHeights();
    this._checkDropdownPosition();
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.navDropdownManager = new NavDropdownHeightManager();
});

// Initialize when sections are loaded in theme editor
document.addEventListener('shopify:section:load', () => {
  if (!window.navDropdownManager) {
    window.navDropdownManager = new NavDropdownHeightManager();
  } else {
    window.navDropdownManager.forceSync();
  }
});

class CollectionChildList extends HTMLElement {
  constructor() {
    super();
    this.nav = document.getElementsByClassName('nav-bar__linklist')[0];
    this.currentCollection = this.dataset.collection;
    this.listContainer = this.querySelector('.child-collections');
    this.childCollectionItems = [];
    this.getCollectionsChildInNav();

    if(this.childCollectionItems.length > 0) {
      this.getDataChildCollectionList();
    }
  }

  getCollectionsChildInNav() {
    let mainItems = this.nav.querySelectorAll('.nav-bar__item');
    Array.from(mainItems).forEach(function(mainItem) {
      let linkE = mainItem.querySelector('.nav-bar__link');
      let link = linkE.href;
      if(!link.includes('#') && link.includes(this.currentCollection)) {
        this.childCollectionItems = linkE.nextElementSibling.children;
        console.log(this.childCollectionItems);
      } else if(!link.includes('#') && !link.includes(this.currentCollection)) {
        this.getCollectionsChildInDropDownLV1(linkE);
      }
    }, this);
  }

  getCollectionsChildInDropDownLV1(linkE) {
    if(linkE.nextElementSibling != null) {
      let dropdownItemsLV1 = linkE.nextElementSibling.children;
    
      Array.from(dropdownItemsLV1).forEach(function(item){
        let linkItemLV1 = item.querySelector('.nav-dropdown__link');
        if(this.childCollectionItems.length < 1) {
          let linkLV1 = linkItemLV1.href;
          
          if(!linkLV1.includes('#') && linkLV1.includes(this.currentCollection)) {
            this.childCollectionItems = linkItemLV1.nextElementSibling.children;
            console.log(this.childCollectionItems);
          }
        }
      }, this);
    } 
  }

  getDataChildCollectionList() {
    Array.from(this.childCollectionItems).forEach(function(item, index) {
      let linkElement = item.querySelector('.nav-dropdown__link');
      let url = linkElement.href + '.json';

      let linkHandle = linkElement.href.split('collections/')[1];
      
      // not generate if link is current collection
      if(linkHandle != this.currentCollection) {
       
        fetch(url, {
          credentials: "same-origin",
          method: "GET"
        })
        .then(res => res.json())
        .then(res => {
          let collection = res.collection;
          this.generateChildCollection(linkElement,collection, index);
        });
      }
    }, this);
  }
  generateChildCollection(linkElement, collection, index) {
    let element = document.createElement('div');
    element.classList.add('child-collection');
    element.dataset.handle = collection.handle;
    element.style.order = index;

    let imageDivWrapper = document.createElement('div');
    imageDivWrapper.classList.add('child-collection--image-wrapper');

    element.append(imageDivWrapper);

    let close = document.createElement('div');
    close.classList.add('child-collection--close');
    close.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.17249 1L11.1725 11" stroke="#7362D4" stroke-width="2"/><path d="M10.8276 1L0.827637 11" stroke="#7362D4" stroke-width="2"/></svg>';

    imageDivWrapper.append(close);

    let imageDiv = document.createElement('div');
    imageDiv.classList.add('child-collection--image');

    if(collection.image != null) {
      let img = document.createElement('img');
      img.src = collection.image.src;
      imageDiv.append(img);
    }

    imageDivWrapper.append(imageDiv);

    let title = document.createElement('div');
    title.classList.add('child-collection--title');
    title.innerText = linkElement.text;

    element.append(title);

    this.listContainer.append(element);
  }
}

customElements.define("collection-child-list", CollectionChildList);

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
          return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
  }
  return formatString.replace(placeholderRegex, value);
};
class SIMService extends HTMLElement {
  constructor() {
    super();

    this.isSIM = this.dataset.simproduct;
    if(this.isSIM == 'true') {
      this.hideVariantSelector();
    }

    this.productQtyInput = this.closest('form').querySelector('.quantity-selector__value');
    this.variantIdField = this.querySelector('.sim_variant_id');
    this.variantPriceField = this.querySelector('.sim_variant_price');
    this.planIdField = this.querySelector('.sim_selling_plan_id');
    this.planQtyField = this.querySelector('.sim_selling_plan_qty');
    this.planQtyRangeField = this.querySelector('.sim_selling_plan_qty_range');
    this.planLabelField = this.querySelector('.sim_selling_plan_label');
    this.planTypeField = this.querySelector('.sim_selling_plan_type');

    this.updateLivePrice();

    this.items = this.querySelectorAll('.product-addon-sim-service__group-item');
    Array.from(this.items).forEach(function(item){
      item.addEventListener('click', this.itemClick.bind(this));
    }, this);

    this.productQtyInput.addEventListener('change', this.changePlanQtyByProductQty.bind(this));
  }
  hideVariantSelector() {
    let variantSelector = document.querySelector('.product-form__option');
    variantSelector.style.display = 'none';
  }
  toggleGroup(e) {
    e.preventDefault();
    let group = e.target.closest('.product-addon-sim-service__group');

    if(group.classList.contains('active')) {
      group.classList.remove('active');
    }else {
      group.classList.add('active');
    }
  }

  itemClick(e) {
    e.preventDefault();
    let currentItem = e.target.closest('.product-addon-sim-service__group-item');
    Array.from(this.items).forEach(function(item) {
      if(item == currentItem) {
        if(item.classList.contains('active')) {
          currentItem.classList.remove('active');
        }else {
          currentItem.classList.add('active');
        }
        
      } else {
        item.classList.remove('active');
      }
    }, this);
    this.setVariantID(currentItem);
    this.setPlanID(currentItem);
    this.setPlanQtyRange(currentItem);
    this.setPlanLabel(currentItem);
    this.setPlanType(currentItem);
    this.changePlanQtyByProductQty(e);
    this.toggleInfo(currentItem);
    this.updateLivePrice();
  }
  setVariantID(currentItem) {
    let variant_id = currentItem.dataset.variant;
    this.variantIdField.value = variant_id;
  }
  setPlanID(currentItem) {
    let plan_id = currentItem.dataset.plan;
    this.planIdField.value = plan_id;
  }

  setPlanQtyRange(currentItem) {
    let planQtyRange = currentItem.dataset.range;
    this.planQtyRangeField.value = planQtyRange;
  }

  setPlanLabel(currentItem) {
    let plan_label = currentItem.querySelector('.item-label').innerText;
    this.planLabelField.value = plan_label;
  }

  setPlanType(currentItem) {
    let type = currentItem.closest('.product-addon-sim-service__group').dataset.type;
    this.planTypeField.value = type;
  }

  changePlanQtyByProductQty(e) {
    let productQty = e.target.value;
    if(!e.target.classList.contains('quantity-selector__value')) {
      productQty = this.productQtyInput.value;
    }
  
    this.planQtyField.value = productQty;
  }
  toggleInfo(currentItem) {
    let group = currentItem.closest('.product-addon-sim-service__group');
    let type = group.dataset.type;

    let infoWrappers = this.querySelectorAll('.product-addon-sim-service__plan-info');
    Array.from(infoWrappers).forEach(function(info){
      if(info.classList.contains('active')) {
        info.classList.remove('active');
      }
    })

    if(type == 'individuals') {
      this.addItemInfoIndividuals(currentItem, group);
      this.setVariantPriceIndividuals(currentItem);
    }else {
      this.addItemInfoBusinesses(currentItem, group);
    }
  }
  setVariantPriceIndividuals(currentItem) {
    let variant_price = currentItem.dataset.price;
    this.variantPriceField.value = variant_price;
  }
  setVariantPriceBusinesses(sale_price) {
    this.variantPriceField.value = sale_price;
  }
  addItemInfoIndividuals(currentItem, group) {
    let infoWrapper = group.querySelector('.product-addon-sim-service__plan-info');

    let price = parseInt(currentItem.dataset.price);
    let month = currentItem.dataset.month;
    let info_1 = '';
    let info_2 = '';

    switch (month) {
      case '12':
        info_1 = Shopify.formatMoney(price) + ' (charged annually)';
        info_2 = Shopify.formatMoney(price/parseInt(month)) + '/month';
        break;
      case '6':
        info_1 = Shopify.formatMoney(price) + ' (charged every 6 months)';
        info_2 = Shopify.formatMoney(price/parseInt(month)) + '/month';
        break

      case 'Monthly':
        info_1 = Shopify.formatMoney(price) + ' (charged monthly)';
        info_2 = Shopify.formatMoney(price) + '/month';
        break;
      default:
        info_1 = '';
        info_2 = '';
        break;
    }
    
    let html = '<div class="plan-info--1">' + info_1 + '</div><div class="plan-info--2">' + info_2 + '</div>';

    infoWrapper.innerHTML = html;
    if(month != null) {
      infoWrapper.classList.add('active');
    }
  }

  addItemInfoBusinesses(currentItem, group) {
    let infoWrapper = group.querySelector('.product-addon-sim-service__plan-info');

    let discount = currentItem.dataset.discount;
    let price = currentItem.dataset.price;
    let sale_price = parseInt(currentItem.dataset.price) - (parseInt(currentItem.dataset.price) * parseInt(discount) / 100);

    this.setVariantPriceBusinesses(sale_price);
    
    let info_1 = Shopify.formatMoney(sale_price) + '/unit';
    let info_2 = discount + '% off';
    
    let html = '<div class="plan-info--1">' + info_1 + '</div><div class="plan-info--2">' + info_2 + '</div>';

    infoWrapper.innerHTML = html;
    infoWrapper.classList.add('active');
  }
  updateLivePrice() {
    let quantity = document.querySelector('.quantity-selector--product .quantity-selector__value').value;
    let livePrice = document.querySelector('.product-form__buy-buttons .live-price');
    let simPriceE = document.querySelector('.sim_variant_price');
    if(livePrice == null) {
      return;
    }

    let defaultPrice = livePrice.dataset.defaultprice;
    let newPrice = parseInt(quantity) * parseInt(defaultPrice);

    if(this.isSIM == 'true') {
      defaultPrice = 0;
    }
    if(simPriceE != null && simPriceE.value != '') {
      newPrice = (parseInt(quantity) * parseInt(defaultPrice)) + (parseInt(quantity) * parseInt(simPriceE.value));
    }

    livePrice.innerText = Shopify.formatMoney(newPrice);
  }
}
customElements.define("sim-service", SIMService);

// Shared utility function for video toggling
function playVideoToggle(container) {

  let images = container.querySelectorAll('.video-wrapper__image');

  
  Array.from(images).forEach(function(image) {
    image.addEventListener('click', function(e) {
      let item = e.target.closest('.video-item');
      if (!item) {
        return;
      }
      
      let video = item.querySelector('video');
      
      if (!video) {
        return;
      }
      
      if(item.dataset.action == 'play-video') {
        item.dataset.action = '';
        video.play();
      }
    });
  });
}

class TrainingVideos extends HTMLElement {
  constructor() {
    super();
    this.parser = new DOMParser();

    this.template = this.dataset.template;
    this.productsContainer = this.querySelector('.training-videos__products');
    this.videosContainer = this.querySelector('.training-videos__videos');
    this.collections = this.querySelectorAll('.training-videos__collection');

    this.collectionActive = '';

    if(this.collections.length > 0) {
      Array.from(this.collections).forEach(function(item){
        item.addEventListener('click', this.toggleCollection.bind(this));
      }, this);
    }
  }
  
  toggleCollection(e) {
    e.preventDefault();

    let collection = e.target.closest('.training-videos__collection');
    Array.from(this.collections).forEach(function(item) {
      if(item == collection) {
        if(item.classList.contains('active')) {
          item.classList.remove('active');
          while (this.productsContainer.firstChild) this.productsContainer.removeChild(this.productsContainer.firstChild);
        } else {
          item.classList.add('active');
          let products = item.dataset.products.split(',');
          this.getProducts(products);
        }
      } else {
        item.classList.remove('active');
      }
    }, this);
    if (this.videosContainer) {
      while (this.videosContainer.firstChild) this.videosContainer.removeChild(this.videosContainer.firstChild);
    }
  }

  getProducts(products) {
    this.progress = 0;
    
    while (this.productsContainer.firstChild) this.productsContainer.removeChild(this.productsContainer.firstChild);
    this.productCarousel = document.createElement('div');
    this.productCarousel.classList.add('training-videos__products-carousel');

    for(let i = 0; i < products.length; i++) {
      let url = '/products/' + products[i] + '?view=' + this.template + '-item';
      fetch(url, {
        credentials: "same-origin",
        method: "GET"
      })
      .then((res) => {
          if(res.status == 404){
              return false;
          }
          return res.text();
        })
      .then(res => this.showProduct(res, i, products.length))
      .catch(err => console.log(err));
    }
  }

  showProduct(res, i, length) {
    let doc = this.parser.parseFromString(res, 'text/html');
    let product = doc.querySelector(".training-videos-item");

    if(this.template == 'training-videos' && product) {
      product.addEventListener('click', this.getVideos.bind(this));
    }  
    
    if (product) {
      product.dataset.order = i;
      this.productCarousel.append(product);
    }

    if(this.productCarousel.children.length == length) {
      this.reOrderItem();
      this.productsContainer.append(this.productCarousel);

      let cellAlign = 'center';
      if(window.innerWidth > 767) {
        cellAlign = 'left';
      }
      let flickityInstance = new Flickity(this.productCarousel, {
        pageDots: false,
        prevNextButtons: true,
        contain: true,
        cellAlign: cellAlign,
        groupCells: true,
        resize: false,
        draggable: !window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches
      });
    }
  }

  reOrderItem() {
    [...this.productCarousel.children].sort((a, b) => parseInt(a.dataset.order) > parseInt(b.dataset.order) ? 1 : -1)
    .forEach(node => this.productCarousel.appendChild(node));
  }

  getVideos(e) {
    e.preventDefault();
    let item = e.target.closest('.training-videos-item');
    if(!item) return;

    if(item.classList.contains('active')) {
      item.classList.remove('active');
    } else {
      let product_items = this.querySelectorAll('.training-videos-item');
      Array.from(product_items).forEach(function(p_item){
        if(p_item == item) {
          p_item.classList.add('active');
        } else {
          p_item.classList.remove('active');
        }
      }, this);

      let product_handle = item.dataset.handle;
      console.log('Fetching videos for product:', product_handle);
      
      if (this.videosContainer) {
        while (this.videosContainer.firstChild) this.videosContainer.removeChild(this.videosContainer.firstChild);

        let url = '/products/' + product_handle + '?view=training-videos';
        console.log('Fetching from URL:', url);
        
        fetch(url, {
          credentials: "same-origin",
          method: "GET"
        })
        .then((res) => {
            console.log('Response status:', res.status);
            if(res.status == 404){
                console.log('Product template not found');
                return false;
            }
            return res.text();
          })
        .then(res => {
            console.log('Response received:', res ? 'Data received' : 'No data');
            this.showVideos(res);
        })
        .catch(err => console.error('Error fetching videos:', err));
      }
    }
  }

  showVideos(res) {
    if (!res) {
      console.log('No video data to show');
      return;
    }
    
    let doc = this.parser.parseFromString(res, 'text/html');
    let videoElement = doc.querySelector(".video-container");
    console.log('Found video container:', videoElement ? 'Yes' : 'No');

    if (videoElement && this.videosContainer) {
      this.videosContainer.innerHTML = '';
      this.videosContainer.appendChild(videoElement);
      playVideoToggle(this.videosContainer);
    }
  }
}
customElements.define("training-videos", TrainingVideos);

class SentriSimNavigation {
  constructor() {
    this.init();
  }

  init() {
    // Get required elements
    this.sectionContainer = document.querySelector('.shopify-sentrisim-tabs');
    if (!this.sectionContainer) return;
    
    this.navScroll = this.sectionContainer.querySelector('.sen-links-scroller');
    if (!this.navScroll) return;

    this.navLinks = this.navScroll.querySelectorAll('.sen-link-scroll__item');
    this.sections = [];
    
    // Get all sections referenced by the navigation
    this.navLinks.forEach(link => {
      const sectionId = link.getAttribute('href');
      if (sectionId) {
        const section = document.querySelector(sectionId);
        if (section) {
          this.sections.push(section);
        }
      }
    });

    // Get the header height
    this.headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    
    // Store initial position of the tabs container
    this.initPosition = this.sectionContainer.getBoundingClientRect().top + window.pageYOffset;
    
    // Set up scroll handlers
    this._setupScrollHandlers();
    
    // Initial checks
    this._checkStickyState();
    this._checkActiveSection();
  }

  _setupScrollHandlers() {
    // Handle scroll events
    window.addEventListener('scroll', () => {
      this._checkStickyState();
      this._checkActiveSection();
    });
    
    // Handle resize events 
    window.addEventListener('resize', () => {
      // Update the initial position on resize
      this.initPosition = this.sectionContainer.getBoundingClientRect().top + window.pageYOffset;
      this._checkStickyState();
    });

    // Handle navigation click events
    this.navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href');
        const targetSection = document.querySelector(targetId);
        
        if (targetSection) {
          const scrollPosition = targetSection.offsetTop - this.headerHeight - this.navScroll.offsetHeight;
          window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  _checkStickyState() {
    const sectionRect = this.sectionContainer.getBoundingClientRect();

    if (sectionRect.top <= this.headerHeight + 1) {
      this.navScroll.classList.add('is-sticky');
    } else {
      this.navScroll.classList.remove('is-sticky');
    }
  }

  _checkActiveSection() {
    const scrollPosition = window.pageYOffset + this.headerHeight + this.navScroll.offsetHeight + 10;

    // Find the current section
    let currentSection = this.sections[0];
    for (const section of this.sections) {
      if (scrollPosition >= section.offsetTop) {
        currentSection = section;
      } else {
        break;
      }
    }

    // Update active states
    this.navLinks.forEach(link => {
      const sectionId = link.getAttribute('href');
      if (currentSection && sectionId === `#${currentSection.id}`) {
        link.classList.add('is-active');
      } else {
        link.classList.remove('is-active');
      }
    });
  }
}

// Initialize the navigation when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  new SentriSimNavigation();

  const productVideos = document.querySelectorAll('.product-video-carousel');
  console.log('Found product video carousels:', productVideos.length);
  
  productVideos.forEach(carousel => {
    const productVideoItems = carousel.querySelectorAll('.product-video-item');
    console.log('Found product video items:', productVideoItems.length);
    
    // Initialize video toggling for any number of videos
    if(productVideoItems.length > 0) {
      playVideoToggle(carousel);
    }

    // Only initialize Flickity if there are multiple videos
    if(productVideoItems.length > 1) {
      const flkty = new Flickity(carousel, {
        freeScroll: true,
        contain: false,
        draggable: true,
        wrapAround: true,
        autoPlay: false,
        pageDots: false
      });

      // Pause all videos when changing slides
      flkty.on('change', function() {
        const videos = carousel.querySelectorAll('video');
        videos.forEach(video => {
          if (!video.paused) {
            video.pause();
            const videoItem = video.closest('.video-item');
            if (videoItem) {
              videoItem.dataset.action = 'play-video';
            }
          }
        });
      });

      // Handle drag events to pause videos
      flkty.on('dragStart', function() {
        const videos = carousel.querySelectorAll('video');
        videos.forEach(video => {
          if (!video.paused) {
            video.pause();
            const videoItem = video.closest('.video-item');
            if (videoItem) {
              videoItem.dataset.action = 'play-video';
            }
          }
        });
      });
    }
  });
});

class ProductFeatureList extends HTMLElement {
  constructor() {
    super();
    this.featureList = this.querySelector('.product-feature-list');
    this.readMoreButton = this.querySelector('.product-feature-read-more');
    this.showMoreText = this.readMoreButton?.querySelector('.show-more-text');
    this.showLessText = this.readMoreButton?.querySelector('.show-less-text');
    
    this.init();
  }

  init() {
    // Only initialize if we're on mobile and have more than 4 items
    if (window.innerWidth >= 1000 || this.querySelectorAll('.product-feature-item').length <= 4) {
      return;
    }

    // Add initial collapsed state
    this.featureList.classList.add('is-collapsed');
    this.readMoreButton.classList.add('is-visible');

    // Add click event listener
    this.readMoreButton.querySelector('button').addEventListener('click', this.toggleReadMore.bind(this));

    // Handle resize events
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1000) {
        this.featureList.classList.remove('is-collapsed');
        this.readMoreButton.classList.remove('is-visible');
      } else {
        this.featureList.classList.add('is-collapsed');
        this.readMoreButton.classList.add('is-visible');
        this.showMoreText.style.display = '';
        this.showLessText.style.display = 'none';
      }
    });
  }

  toggleReadMore() {
    const isCollapsed = this.featureList.classList.contains('is-collapsed');
    
    if (isCollapsed) {
      this.featureList.classList.remove('is-collapsed');
      this.showMoreText.style.display = 'none';
      this.showLessText.style.display = '';
    } else {
      this.featureList.classList.add('is-collapsed');
      this.showMoreText.style.display = '';
      this.showLessText.style.display = 'none';
    }
  }
}

customElements.define('product-feature-list', ProductFeatureList);

class SpecificationsList extends HTMLElement {
  constructor() {
    super();
    this.specList = this.querySelector('.specifications-table');
    this.readMoreButton = this.querySelector('.specifications-read-more');
    this.showMoreText = this.readMoreButton?.querySelector('.show-more-text');
    this.showLessText = this.readMoreButton?.querySelector('.show-less-text');
    
    this.init();
  }

  init() {
    // Only initialize if we're on mobile and have more than 4 items
    if (this.querySelectorAll('.specifications-table li').length <= 4) {
      return;
    }

    // Add initial collapsed state
    this.specList.classList.add('is-collapsed');
    this.readMoreButton.classList.add('is-visible');

    // Add click event listener
    this.readMoreButton.querySelector('button').addEventListener('click', this.toggleReadMore.bind(this));

  }

  toggleReadMore() {
    const isCollapsed = this.specList.classList.contains('is-collapsed');
    
    if (isCollapsed) {
      this.specList.classList.remove('is-collapsed');
      this.showMoreText.style.display = 'none';
      this.showLessText.style.display = '';
    } else {
      this.specList.classList.add('is-collapsed');
      this.showMoreText.style.display = '';
      this.showLessText.style.display = 'none';
    }
  }
}

customElements.define('specifications-list', SpecificationsList);

class ProductInfoSticky {
  constructor() {
    this.init();
  }

  init() {
    const productInfoStickyBar = document.querySelector(".product-add-to-cart-sticky");
    const elementTrigger = document.querySelector('.product-form__buy-buttons');
    
    if (!productInfoStickyBar || !elementTrigger) return;

    const handleScroll = () => {
      const scrollpos = window.scrollY;
      const elementTriggerHeight = elementTrigger.offsetHeight + elementTrigger.getBoundingClientRect().top + scrollpos;

      if (scrollpos > elementTriggerHeight) {
        productInfoStickyBar.classList.add('is-visible');
        document.body.classList.add('show-product-add-to-cart-sticky');
      } else {
        productInfoStickyBar.classList.remove('is-visible');
        document.body.classList.remove('show-product-add-to-cart-sticky');
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductInfoSticky();
});

// Initialize when sections are loaded in theme editor
document.addEventListener('shopify:section:load', () => {
  new ProductInfoSticky();
});

class CollectionToolbarSticky {
  constructor() {
    this.toolbar = document.querySelector('.collection__toolbar');
    if (!this.toolbar) return;

    this.initObserver();
  }

  initObserver() {
    const sentinel = document.createElement('div');
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.height = '1px';
    this.toolbar.parentNode.insertBefore(sentinel, this.toolbar);

    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          this.toolbar.classList.add('is-sticky');
        } else {
          this.toolbar.classList.remove('is-sticky');
        }
      },
      {
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
        threshold: 0,
      }
    );

    observer.observe(sentinel);
  }
}

document.addEventListener('DOMContentLoaded', () => new CollectionToolbarSticky());

document.addEventListener('shopify:section:load', (event) => {
  if (event.detail.container.querySelector('.collection__toolbar')) {
    new CollectionToolbarSticky();
  }
});

function wrapTextContentAfterStrong() {
  // Find all li elements that contain strong tags
  const listItems = document.querySelectorAll('li > strong');
  
  listItems.forEach(strongElement => {
    const parentLi = strongElement.parentElement;
    
    // Create wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'text-content-wrapper';
    
    // Get all nodes after the strong tag
    let currentNode = strongElement.nextSibling;
    const nodesToMove = [];
    
    // Collect all following nodes
    while (currentNode) {
      nodesToMove.push(currentNode);
      currentNode = currentNode.nextSibling;
    }
    
    // Move all collected nodes into the wrapper
    nodesToMove.forEach(node => wrapper.appendChild(node));
    
    // Insert wrapper after strong tag
    strongElement.after(wrapper);
  });
}

// Run when DOM is loaded
document.addEventListener('DOMContentLoaded', wrapTextContentAfterStrong);

// Run when Shopify sections are loaded (for theme editor)
document.addEventListener('shopify:section:load', wrapTextContentAfterStrong);

// Add thumbnail carousel functionality to ProductGallery
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-gallery__thumbnail-carousel').forEach(thumbnailList => {
    if (thumbnailList.children.length > 1) {
      const productGallery = thumbnailList.closest('.product-gallery');
      const mainCarousel = productGallery ? productGallery.querySelector('.product-gallery__carousel') : null;
      
      // Initialize the thumbnail carousel
      new Flickity(thumbnailList, {
        pageDots: false,
        prevNextButtons: true,
        contain: true,
        cellAlign: 'left',
        draggable: true,
        wrapAround: false,
        groupCells: true,
        asNavFor: mainCarousel ? '.product-gallery__carousel' : null,
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 60, y2: 45,
          x3: 15
        },
        // Make thumbnails select their corresponding slide
        on: {
          ready: function() {
            const selectedItem = thumbnailList.querySelector('.is-nav-selected');
            if (selectedItem) {
              this.select(this.slides.indexOf(selectedItem));
            }
          }
        }
      });
      
      if (mainCarousel && mainCarousel.flickity) {
        mainCarousel.flickity.reloadCells();
      }
    }
  });
});


